import Handlebars from "../handlebars/handlebars";
import shippingEstimateService from "./shippingEstimateService";
import errorResponseHandler from "../errors/errorResponseHandler";
import shippingEstimateHtml from "./shippingEstimate.hbs";
import promoProductsList from "../_data/promoProductsList";
import notalProductsList from "../_data/notalProductsList";
import directMailProductsList from "../_data/directMailProductsList";
import userAddressesService from "../_services/userAddressesService";

const COUNTRY_ELEMENT_SELECTOR = '.js-element--country';
const STATE_ELEMENT_SELECTOR = '.js-element--state';
const ZIP_ELEMENT_SELECTOR = '.js-element--zip';
const QUOTE_ELEMENT_SELECTOR = '.js-element--quote';
const GETQUOTE_ACTION_SELECTOR = '.js-action--get-quote';
const ADDRESS_ELEMENT_SELECTOR = '.js-element--address';
const USE_SAVED_ADDRESS_SELECTOR = '.js-action--use-saved-address';
const SUBMIT_NEW_ADDRESS_SELECTOR = '.js-action--submit-new-address';

class ShippingEstimateController {
    constructor (modalInstance, container, project, loggedIn, canSelectServices, isProductPage) {
        this.state = {
            loading: true,
            estimate: null,
            addresses: [],
            selectedAddressId: null,
            showManualEntry: false,
            loggedIn: loggedIn,
            canSelectServices: canSelectServices === undefined ? true : canSelectServices,
            errors: {},
            selectedServiceId: null,
            isProductPage: isProductPage,
            activeServices: [
                1, // Counter Pickup
                31, // FedEx Ground
                35, // FedEx Home Delivery
                30, // FedEx 2 Day
                25, // FedEx Priority Overnight
                // 266, // Direct Mail Services (postage charged after address list processing)
                // 332, // Free USPS Sample Shipping (Paper Sample Book)
                // 336, // No Shipping - Custom Product Order (Business Hub/MyProduct Service)
                1942, // Ship to Multiple Addresses (additional shipping charges may apply)
            ],
        };

        this.modalInstance = modalInstance;
        this.container = container;
        this.template = shippingEstimateHtml;
        this.project = project;
        this.cartItemsIds = [];
        this.isProductPage = isProductPage === undefined ? false : isProductPage;

        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.updateEstimate = this.updateEstimate.bind(this);
        this.checkForDivisonKAFENE = this.checkForDivisonKAFENE.bind(this);
        this.checkForDivisonNOTAL = this.checkForDivisonNOTAL.bind(this);
        this.checkForPaperSampleBook = this.checkForPaperSampleBook.bind(this);
        this.checkForBusinessHubProduct = this.checkForBusinessHubProduct.bind(this);
        this.checkForDirectMailProducts = this.checkForDirectMailProducts.bind(this);
        this.updatePromoShipping = this.updatePromoShipping.bind(this);
        this.disableLoadingState = this.disableLoadingState.bind(this);
        this.setValid = this.setValid.bind(this);

        this.container.addEventListener('click', this.handleClick, false);
        this.container.addEventListener('change', this.handleChange, false);

        this.getShippingEstimate();
        this.getCartItemIds();
    }

    render () {
        this.container.innerHTML = this.template(this.state);
    }

    getCartItemIds () {
        this.project.items.forEach( item => {
            this.cartItemsIds.push(item.productIdWithPrefix);
        });
    }

    getShippingEstimate () {
        this.enableLoadingState();

        if (this.isProductPage) {
            const promises = [
                // Direct API: fetch countries/defaults for form
                shippingEstimateService.getShippingDefaults(),
                shippingEstimateService.getShippingCountries(1),
            ];

            if (this.state.loggedIn) {
                promises.push(userAddressesService.getUserAddresses());
            }

            return Promise.all(promises)
                .then(([defaults, countries, addresses]) => {
                    const defaultCountry = countries.find(country => country.id === defaults.defaultCountryId);
                    
                    this.state.estimate = {
                        country: defaultCountry,
                        countries: countries,
                        states: defaultCountry.regions || [],
                        state: null,
                        postalCode: '',
                        quotes: []
                    };

                    if (!this.state.loggedIn || !addresses || addresses.length === 0) {
                        this.state.showManualEntry = true;
                    }
                    
                    if (addresses && addresses.length > 0) {
                        this.state.addresses = addresses;
                        const defaultAddr = this.state.addresses.find(address => address?.addressType?.includes("SHIP_TO"));
                        this.state.selectedAddressId = defaultAddr.id;

                        // Auto-populate and auto-estimate
                        const addrCountry = countries.find(country => country.id === defaultAddr.country.id);
                        this.state.estimate.country = addrCountry;
                        this.state.estimate.states = addrCountry.regions || [];
                        this.state.estimate.state = (addrCountry.regions || []).find(region => region.id === defaultAddr.state.id) || null;
                        this.state.estimate.postalCode = defaultAddr.zip;

                        return this.autoEstimateWithAddress(defaultAddr);
                    }
                })
                .catch(errorResponseHandler.generateErrorHandler())
                .finally(this.disableLoadingState);
        }

        // Cart page flow
        const promises = [
            shippingEstimateService.getEstimate(this.project),
            shippingEstimateService.getShippingCountries(1)
        ];

        if (this.state.loggedIn) {
            promises.push(userAddressesService.getUserAddresses());
        }

        return Promise.all(promises)
            .then(([estimate, countries, addresses]) => {
                this.fullCountries = countries;
                this.updateEstimate(estimate);

                if (addresses && addresses.length > 0) {
                    this.state.showManualEntry = false;
                    this.state.addresses = addresses;
                    const defaultAddr = this.state.addresses.find(address => address?.addressType?.includes('SHIP_TO')) || this.state.addresses[0];
                    this.state.selectedAddressId = defaultAddr.id;
                    
                    return this.autoEstimateWithAddress(defaultAddr);
                } else if (this.state.loggedIn) {
                    // Logged in but no saved addresses — show add new address form
                    this.state.showManualEntry = true;
                    this.state.estimate = {
                        ...JSON.parse(JSON.stringify(this.state.estimate)),
                    };
                }
            })
            .then(this.checkForDivisonKAFENE)
            .then(this.checkForDivisonNOTAL)
            .then(this.checkForPaperSampleBook)
            .then(this.checkForBusinessHubProduct)
            .then(this.checkForDirectMailProducts)
            .then(this.updatePromoShipping)
            .catch(errorResponseHandler.generateErrorHandler())
            .finally(this.disableLoadingState);
    }

    refreshShippingEstimate () {
        this.enableLoadingState();

        if (this.isProductPage) {
            // Direct API: server combines cart weight + product weight automatically
            return shippingEstimateService.getProductShippingEstimate(
                configureglobals.cquote.productIdWithPrefix,
                configureglobals.cquote.totalOunces,
                this.state.estimate.country.id,
                this.state.estimate.state?.id || 0,
                this.state.estimate.postalCode
            )
            .then(quotes => {
                this.state.estimate = {
                    ...JSON.parse(JSON.stringify(this.state.estimate)),
                    quotes: quotes
                };
            })
            .then(this.setValid)
            .catch(errorResponseHandler.generateErrorHandler({
                list: e => {
                    this.setValid();
                    e.errors.forEach(error => this.state.errors[error.field] = error.message);
                },
            }))
            .finally(this.disableLoadingState);
        }

        // Cart page flow (SDK)
        return shippingEstimateService.refreshEstimate(this.state.estimate)
            .then(this.updateEstimate)
            .then(this.setValid)
            .catch(errorResponseHandler.generateErrorHandler({
                list: e => {
                    this.setValid();
                    e.errors.forEach(error => this.state.errors[error.field] = error.message);
                },
            }))
            .finally(this.disableLoadingState);
    }

    autoEstimateWithAddress (address) {
        if (this.isProductPage) {
            // Product page: always use productIdWithPrefix + totalOunces for accurate weight
            // Still set address on project if cart has items (for cart page benefit)
            const setAddressPromise = this.project.items.length > 0
                ? shippingEstimateService.setProjectShipToAddress(this.project.id, address.id)
                : Promise.resolve();

            return setAddressPromise
                .then(() => shippingEstimateService.getProductShippingEstimate(
                    configureglobals.cquote.productIdWithPrefix,
                    configureglobals.cquote.totalOunces,
                    address.country.id,
                    address.state?.id || 0,
                    address.zip
                ))
                .then(quotes => {
                    this.state.estimate = {
                        ...JSON.parse(JSON.stringify(this.state.estimate)),
                        quotes: quotes
                    };
                    this.updateSelectedService();
                    this.render();
                });
        }
        
        if (this.project.items.length > 0) {
            // Cart has items: PATCH address → get estimate with projectId (residential detection)
            return shippingEstimateService.setProjectShipToAddress(this.project.id, address.id)
                .then(() => shippingEstimateService.getProjectShippingEstimate(
                    this.project.id,
                    address.country.id,
                    address.state?.id || 0,
                    address.zip,
                    0
                ))
                .then(quotes => {
                    this.state.estimate = {
                        ...JSON.parse(JSON.stringify(this.state.estimate)),
                        quotes: quotes
                    };
                    this.updateSelectedService();
                    this.render();
                });
        }

        // Empty cart: direct API (no residential detection)
        return shippingEstimateService.getProjectShippingEstimate(
            null,
            address.country.id,
            address.state?.id || 0,
            address.zip,
            0
        )
        .then(quotes => {   
            this.state.estimate = {
                ...JSON.parse(JSON.stringify(this.state.estimate)),
                quotes: quotes
            };
            this.updateSelectedService();
            this.render();
        });
    }

    submitNewAddress () {
        // Collect form values
        const newAddress = {
            firstName: this.container.querySelector('.js-element--firstName')?.value || '',
            lastName: this.container.querySelector('.js-element--lastName')?.value || '',
            address: this.container.querySelector('.js-element--address1')?.value || '',
            address2: this.container.querySelector('.js-element--address2')?.value || '',
            city: this.container.querySelector('.js-element--city')?.value || '',
            countryId: parseInt(this.container.querySelector('.js-element--country')?.value) || 1,
            stateId: parseInt(this.container.querySelector('.js-element--state')?.value) || 0,
            zip: this.container.querySelector('.js-element--zip')?.value || '',
            phone: this.container.querySelector('.js-element--phone')?.value || '',
            company: this.container.querySelector('.js-element--company')?.value || '',
            addressType: 'SHIP_TO'
        };

        // Validate required fields
        this.state.errors = {};
        if (!newAddress.firstName) this.state.errors.firstName = 'First name is required';
        if (!newAddress.lastName) this.state.errors.lastName = 'Last name is required';
        if (!newAddress.address) this.state.errors.address = 'Address is required';
        if (!newAddress.city) this.state.errors.city = 'City is required';
        if (!newAddress.phone) this.state.errors.phone = 'Phone is required';
        if (!newAddress.zip) this.state.errors.postalCode = 'Zip code is required';
        if (!newAddress.stateId) this.state.errors.state = 'State is required';

        if (Object.keys(this.state.errors).length > 0) {
            this.render();
            return Promise.resolve();
        }

        this.enableLoadingState();

        return userAddressesService.createAddress(newAddress)
            .then(savedAddress => {
                // Add to local list and select it
                this.state.addresses.push(savedAddress);
                this.state.selectedAddressId = savedAddress.id;
                this.state.showManualEntry = false;

                // Get estimate with the new address
                return this.autoEstimateWithAddress(savedAddress);
            })
            .catch(errorResponseHandler.generateErrorHandler())
            .finally(this.disableLoadingState);
    }

    updateSelectedService () {
        if (this.project.shippingSummary && this.state.estimate.quotes) {
            const currentService = this.state.estimate.quotes.find(q =>
                q.description === this.project.shippingSummary.description
            );

            if (currentService) {
                this.state.selectedServiceId = currentService.id;
            } else {
                // Previously set service no longer available — clear it
                this.state.selectedServiceId = null;
                return Collaterate.Project.removeShippingService(this.project)
                    .then(updatedProject => {
                        this.project = updatedProject;
                        // Dispatch directly on the cart container
                        const cartContainer = document.getElementById('spdcCart');
                        if (cartContainer) {
                            cartContainer.dispatchEvent(new CustomEvent('ProjectUpdated', {
                                detail: updatedProject,
                                bubbles: false
                            }));
                        }
                    })
                    .catch(errorResponseHandler.generateErrorHandler());
            }
        }
    }

    // Only show ground shipping for promo products
    updatePromoShipping () {
        if (promoProductsList && promoProductsList.some(value => this.cartItemsIds.includes(value))) {
            this.state.activeServices = [
                31, // FedEx Ground
                35 // FedEx Home Delivery
            ]
        };
    }

    // KAFENE Division users - Hide FedEx Overnight & 2 Day for users
    checkForDivisonKAFENE () {
        if (this.state.loggedIn === true && globalpageglobals?.cuser?.division !== null && globalpageglobals?.cuser?.division?.id === 28909) {
            this.state.activeServices = [
                1, // Counter Pickup
                31, // FedEx Ground
                35, // FedEx Home Delivery
                1942 // Ship to Multiple Addresses (additional shipping charges may apply)
            ]
        }
    }

    // Notal Vision Division logic - If user is in Notal Vision divisions and any notalProductsList items are in the cart, only show FedEx Ground Shipping
    checkForDivisonNOTAL () {
        if (this.state.loggedIn === true && globalpageglobals?.cuser?.division !== null && globalpageglobals?.cuser?.division?.id === 85527) {
            if (notalProductsList && notalProductsList.some(value => this.cartItemsIds.includes(value))) {
                this.state.activeServices = [
                    31, // FedEx Ground
                    35, // FedEx Home Delivery
                ]
            }
        }
    }

    // If the 'Paper Sample Book' is the only product in the cart, set to Free USPS Shipping
    checkForPaperSampleBook () {
        if (this.cartItemsIds.includes('SLS_47779') && this.project.items.length === 1) {
            this.state.activeServices = [
                332, // Free USPS Shipping (Paper Sample Book)
            ]
        }
    }

    // No Shipping - Custom Product Order (for new Business Hub "Create New Product" product)
    checkForBusinessHubProduct () {
        if (this.cartItemsIds.includes('SLS_52756') && this.project.items.length === 1) {
            this.state.activeServices = [
                336, // No Shipping - Custom Product Order (Business Hub/MyProduct Service)
            ]
        }
    }

    // All products in cart are 'Direct Mail Product' and 'Paper Sample Book'
    checkForDirectMailProducts () {
        const directMailItemsInCart = directMailProductsList.filter(value => this.cartItemsIds.includes(value));
        
            if (this.project.items.length > 0 && this.project.items.length === directMailItemsInCart.length) {
            this.state.activeServices = [
                266, // Direct Mail Services (postage charged after address list processing)
            ]
        }   
    }

    setShippingEstimate (shippingService) {
        this.enableLoadingState();

        // If estimate is still a frozen SDK object, use original flow
        if (typeof this.state.estimate.getQuoteById === 'function') {
            return shippingEstimateService.setProjectShippingService(
                this.project.id,
                shippingService.internalId.shippingServiceId,
                shippingService.isVendorService,
                this.state.selectedAddressId
            )
                .then(this.modalInstance.close)
                .catch(errorResponseHandler.generateErrorHandler())
                .finally(this.disableLoadingState);
        }

        // Estimate was replaced with plain object (after address change)
        // Re-fetch SDK estimate to get properly typed quote, then set it
        return fetch(`/rest/storefront/projects/v2/${this.project.id}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/merge-patch+json' },
            body: JSON.stringify({
                shippingService: {
                    shippingServiceId: shippingService.internalId.shippingServiceId,
                    isVendorService: shippingService.isVendorService,
                    referenceNumber1: null,
                    referenceNumber2: null,
                    fedExReferenceNumber: null,
                    isUSPSService: false
                }
            })
        })
        .then(res => res.json())
        .then(() => Collaterate.Project.getCart())
        .then(this.modalInstance.close)
        .catch(errorResponseHandler.generateErrorHandler())
        .finally(this.disableLoadingState);
    }

    updateEstimate (shippingEstimate) {
        this.state.estimate = shippingEstimate;
    }

    handleClick (e) {
        if (e.target.matches(GETQUOTE_ACTION_SELECTOR)) {
            e.preventDefault();
            this.refreshShippingEstimate();
        }
        if (e.target.matches(USE_SAVED_ADDRESS_SELECTOR)) {
            e.preventDefault();
            this.state.showManualEntry = false;

            const addressId = this.state.previousSelectedAddressId || this.state.selectedAddressId;
            const address = this.state.addresses.find(a => a.id === addressId) || this.state.addresses[0];
            this.state.selectedAddressId = address.id;

            this.enableLoadingState();
            this.autoEstimateWithAddress(address)
                .catch(errorResponseHandler.generateErrorHandler())
                .finally(this.disableLoadingState);
            return;
        }

        if (e.target.matches(SUBMIT_NEW_ADDRESS_SELECTOR)) {
            e.preventDefault();
            this.submitNewAddress();
            return;
        }
    }

    handleChange (e) {
        if (e.target.matches(COUNTRY_ELEMENT_SELECTOR)) {
            if (this.isProductPage || this.state.showManualEntry) {
                const countryId = parseInt(e.target.value);
                const countriesList = this.fullCountries || this.state.estimate.countries;
                const country = countriesList.find(c => c.id === countryId);
                this.state.estimate = {
                    ...this.state.estimate,
                    country: country,
                    states: country.regions || [],
                    state: null,
                };
                this.render();
            } else {
                this.state.estimate.country = this.state.estimate.getCountryById(e.target.value);
                this.refreshShippingEstimate();
            }
            return;
        }

        if (e.target.matches(STATE_ELEMENT_SELECTOR)) {
            if (this.isProductPage || this.state.showManualEntry) {
                const stateId = parseInt(e.target.value);
                this.state.estimate.state = this.state.estimate.states.find(s => s.id === stateId) || null;
            } else {
                this.state.estimate.state = this.state.estimate.getStateById(e.target.value);
            }
            return;
        }

        if (e.target.matches(ZIP_ELEMENT_SELECTOR)) {
            this.state.estimate.postalCode = e.target.value;
            return;
        }

        if (e.target.matches(QUOTE_ELEMENT_SELECTOR)) {
            let quote;
            
            if (typeof this.state.estimate.getQuoteById === 'function') {
                quote = this.state.estimate.getQuoteById(e.target.id);
            } else {
                quote = this.state.estimate.quotes.find(q => q.id === e.target.id);
            }
            this.setShippingEstimate(quote);
            return;
        }

        if (e.target.matches(ADDRESS_ELEMENT_SELECTOR)) {
            if (e.target.value === 'new') {
                this.state.previousSelectedAddressId = this.state.selectedAddressId;
                this.state.showManualEntry = true;
                this.state.selectedAddressId = null;
                // Reset country to the full version from countries list (has hasRegions/hasPostalCodes)
                const currentCountryId = this.state.estimate.country?.id || 1;
                const countriesList = this.fullCountries || this.state.estimate.countries;
                const fullCountry = countriesList.find(country => country.id === currentCountryId);
                const currentStates = fullCountry?.regions || this.state.estimate.states || [];

                this.state.estimate = {
                    ...JSON.parse(JSON.stringify(this.state.estimate)),
                    countries: countriesList,
                    country: fullCountry || this.state.estimate.country,
                    states: currentStates,
                    state: null,
                    postalCode: '',
                    quotes: []
                };

                this.render();
            } else {
                const addressId = parseInt(e.target.value);
                this.state.selectedAddressId = addressId;
                const address = this.state.addresses.find(a => a.id === addressId);

                // Replace frozen SDK estimate with plain object
                this.state.estimate = {
                    ...JSON.parse(JSON.stringify(this.state.estimate)),
                    country: address.country,
                    states: address.country.regions || this.state.estimate.states,
                    state: address.state || null,
                    postalCode: address.zip
                };

                this.enableLoadingState();
                this.autoEstimateWithAddress(address)
                    .finally(this.disableLoadingState);
            }
            return;
        }
    }

    enableLoadingState () {
        this.state.loading = true;
        this.render();
    }

    disableLoadingState (result) {
        this.state.loading = false;
        this.render();
        return result;
    }

    setValid (result) {
        this.state.errors = {};
        return result;
    }
}
export default ShippingEstimateController;